var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "input-group",
    class: {
      'input-group-invalid': _vm.isInvalid,
      'input-group-disabled': _vm.isDisabled
    }
  }, [_c('label', [_c('span', {
    staticClass: "label",
    class: {
      'required': _vm.isRequired
    }
  }, [_vm._t("default", function () {
    return [_vm._v(_vm._s(_vm.label))];
  })], 2), _c('input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: _vm.mask,
      expression: "mask"
    }, {
      name: "model",
      rawName: "v-model",
      value: _vm.inputValue,
      expression: "inputValue"
    }],
    attrs: {
      "type": "text",
      "inputmode": "numeric",
      "disabled": _vm.isDisabled,
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": _vm.inputValue
    },
    on: {
      "blur": function blur() {
        return _vm.validate();
      },
      "input": [function ($event) {
        if ($event.target.composing) { return; }
        _vm.inputValue = $event.target.value;
      }, function () {
        return _vm.inputHandle();
      }]
    }
  }), _vm.isInvalid ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errorMessage))]) : _vm._e()])]);
}
var staticRenderFns = []

export { render, staticRenderFns }